import { Input } from "antd";
import { SearchOutlined, FilterFilled } from '@ant-design/icons';

export const Get = (dataIndex) => ({
    title: "Currency",   // 👈 yahan add karo
    dataIndex: dataIndex,
    key: dataIndex,
    align: "right",
    filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
    }) => (
        <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Type text here"
            value={selectedKeys[0]}
            onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
        />
    ),

    filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,

    onFilter: (value, record) =>
        record[dataIndex]
            ?.toString()
            .toLowerCase()
            .includes(value.toLowerCase()),

    sorter: (a, b) =>
        a[dataIndex]?.toString().localeCompare(b[dataIndex]?.toString()),
});